export const NEED_ACTION_BADGE_QA = 'need-action-badge';
export const LOYALTY_PRO_ICON_QA = 'loyalty-pro-icon';
